export const initialValuesIngCollaborator = {
	generalAbilities: "",
	workingRegion: "",
	visitAbilities: "",
	visitTransportations: "",

}
